/**
 * Created by antonio on 17/02/15.
 */
define('boxes/helpers/payment-renderer-helper',['jquery', 'boxes/helpers/formValidation'], function($, formValidation) {
    'use strict';

    function setupMustacheTemplate($form, mustacheClass, formTemplateData) {
        if (formTemplateData === undefined) {
            return;
        }
        $form.mustache(mustacheClass, formTemplateData, {method: 'html'});
    }

    function setupAccountSelectionHandler($box, templateCode, formTemplate) {
        var code = '.' + templateCode.toLowerCase();
        var $stored = $box.find(code).find('.stored');
        if ($stored.length < 1) {
            return;
        }
        $stored.show();

		var isWithdraw = (formTemplate.paymentMethod.paymentType === 'withdraw');

        $stored.on('change', function() {
            var storedData = $(this).find('option:selected').data();
            $.each(storedData, function(attribute, value) {
                var $injectElement;
                if('amount' === attribute) {
                    $injectElement = $box.find('[name="' + attribute + '"]');
					if(isWithdraw){
						// TODO: I think we should set amount for withdraws as well, this came from Business change of mind
						value = '';
					}
                } else {
                    $injectElement = $box.find(code + ' [name="' + attribute + '"]');
                }

				// Remove validation errors on any of the injected elements
				var $inputParent = $injectElement.parent();
				$inputParent.removeClass('has-error').addClass('is-valid');
				$inputParent.popover('destroy');


                $injectElement.val(value);
                $injectElement.change();

				// Update summary of the form if exists
				var summaryElements = $box.find(code).find('.summary');
				var summaryElement = summaryElements.find('.' + attribute);
				summaryElement.text(value);

            });
        });
    }

	function setupDeselectAccountWhenAddingExternalId($paymentMethodForm){
		var $externalId = $paymentMethodForm.find('.externalid');
		$externalId.off('focusin').on('focusin', function(){
			var $accountSelectionDropDownFirstOption = $paymentMethodForm.find('.stored option:eq(0)'); // first option = "Select Credit Card" or "Select account"
			if ($accountSelectionDropDownFirstOption.length > 0 && !$accountSelectionDropDownFirstOption.is(':selected')) { // a stored credit card or account is selected
				$externalId.val(''); // empty credit card number or external account id
				$accountSelectionDropDownFirstOption.prop('selected', true); // deselect player card or account whowing "Select Credit Card" or "Select account"
				var $stored = $paymentMethodForm.find('.stored');
				$stored.change();
			}
		});
	}

    function triggerAccountSelectionEvent($box, templateCode) {
        var code = '.' + templateCode.toLowerCase();
        $box.find(code).find('.stored').change();
    }

    function addValidations(formTemplate, paymentBox) {
        var $validationElements = paymentBox.$box.find('.amount-box, ' + formTemplate.getSelectorClass() + '');
        var $form = paymentBox.$box.find('form.form-validation');
        formValidation.setupValidation($form, $validationElements, paymentBox);
        formValidation.setupFocusPopover($validationElements);
    }

    function reInitializeAmountAndFeeBoxes(paymentBox){
        var $amountBox = paymentBox.$box.find('.amount-box');
        var $amountInput = $amountBox.find('input');
        $amountInput.prop('disabled', false);
        $amountBox.parent().show();
        $amountInput.val('');
        paymentBox.$box.find('.fee-box').show();
    }

    var paymentRendererHelper  = {};
    paymentRendererHelper.setupMustacheTemplate = setupMustacheTemplate;
    paymentRendererHelper.setupAccountSelectionHandler = setupAccountSelectionHandler;
    paymentRendererHelper.triggerAccountSelectionEvent = triggerAccountSelectionEvent;
    paymentRendererHelper.addValidations = addValidations;
    paymentRendererHelper.reInitializeAmountAndFeeBoxes = reInitializeAmountAndFeeBoxes;
	paymentRendererHelper.setupDeselectAccountWhenAddingExternalId = setupDeselectAccountWhenAddingExternalId;
    return paymentRendererHelper;
});

